var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterLink',{staticClass:"section__link",attrs:{"to":_vm.to}},[_c('div',[_vm._v(" "+_vm._s(_vm.formattedLabel.start)+" "),_c('span',{staticClass:"section__nowrap"},[_vm._v(_vm._s(_vm.formattedLabel.last))])]),_c('Icon',{attrs:{"id":"leaves"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }